import IBibleSettings from "../interfaces/IBibleSettings";
import BibleVersions from "./BibleVersions";
import { isPlatform } from "@ionic/react";
import { ReadingPlanCodes } from "./ReadingPlans";

export const DefaultBibleSessionInfo = {
    nextUnreadSession: `/bible/${ReadingPlanCodes.ccrbrp}/0`,
    scheduledSession: `/bible/${ReadingPlanCodes.ccrbrp}/0`,
    defaultVersion: BibleVersions.esv,
}

export const DefaultBibleSettings: IBibleSettings = {
    id: 0,
    defaultVersion: BibleVersions.esv,
    activeReadingPlanId: isPlatform('hybrid') ? 1 : 0,
    fontSize: 14,
    font: '',
    audioSpeed: 1,
    audioScroll: true,
    tiltScroll: false,
    colorTheme: 'default',
    strongs: false,
    morphology: false,
    footnotes: false,
    crossReferences: false,
    screenOn: false,
    hideMenu: 'never',
}